import { api } from './api';
import { PromoImage } from '../types';

export const promoImagesService = {
  async getPromoImages(): Promise<PromoImage[]> {
    const response = await api.get<PromoImage[]>('/promo-images');
    return response.data;
  },

  async getPromoImage(id: string): Promise<PromoImage> {
    const response = await api.get<PromoImage>(`/promo-images/${id}`);
    return response.data;
  },

  async createPromoImage(data: { name: string; image: File; defaultSize: 'single' | 'horizontal' | 'square' | 'full_page' | 'footer' | 'header_2x1' | 'header_2x2'; brandId: string | null; isForEndUsers?: boolean; fillDate?: boolean }): Promise<PromoImage> {
    // Convert File to Base64
    const imageData = await new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result as string;
        // Remove data URL prefix (e.g., "data:image/png;base64,")
        const base64Data = base64.split(',')[1];
        resolve(base64Data);
      };
      reader.onerror = reject;
      reader.readAsDataURL(data.image);
    });

    const response = await api.post<PromoImage>('/promo-images', {
      name: data.name,
      imageData,
      imageMimeType: data.image.type,
      defaultSize: data.defaultSize,
      brandId: data.brandId,
      isForEndUsers: data.isForEndUsers,
      fillDate: data.fillDate,
    });
    return response.data;
  },

  async updatePromoImage(id: string, data: { name?: string; image?: File; defaultSize?: 'single' | 'horizontal' | 'square' | 'full_page' | 'footer' | 'header_2x1' | 'header_2x2'; brandId?: string | null; isForEndUsers?: boolean; fillDate?: boolean }): Promise<PromoImage> {
    const { image, ...rest } = data;
    const payload: Record<string, unknown> = { ...rest };

    // Soubor je nepovinný - bez něj se mění jen metadata a obrázek zůstává.
    if (image) {
      payload.imageData = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64 = reader.result as string;
          resolve(base64.split(',')[1]);
        };
        reader.onerror = reject;
        reader.readAsDataURL(image);
      });
      payload.imageMimeType = image.type;
    }

    const response = await api.patch<PromoImage>(`/promo-images/${id}`, payload);
    return response.data;
  },

  async deletePromoImage(
    id: string,
  ): Promise<{ hidden?: boolean; deleted?: boolean; message?: string }> {
    const response = await api.delete(`/promo-images/${id}`);
    return response.data;
  },
};
